<div class="modal-header">
		<h2 i18n="@@invoices.quickpayment.quick_payment_link">Quick Payment Link</h2>
		<button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="activeModal.dismiss()">
				<svg version="1.1" x="0px" y="0px" width="14" height="14"  viewBox="0 0 14 14">
						<path class="icon-stroke" fill="none" stroke-width="2" stroke-linecap="square" d="M2.8,11.2l8.5-8.5 M2.8,2.8l8.5,8.5"/>
				</svg>
		</button>
</div>
<div class="modal-body" [hidden]="paymentResponse">
		<div class="quick-payment" [hidden]="paymentResponse">
				<form [formGroup]="quickPaymentForm" (ngSubmit)="submit()" class="quick-payment__form">
						<fieldset class="inv-to" [ngClass]="{'has-error': submitted && quickPaymentForm.get('client_id').errors?.required}">
								<select 
									app-select2 
									[options]="{
										ajax: {url: clientListApi},
										idColumn: 'id',
										textColumn: 'full_name',
										dropdownParent: 'form.quick-payment__form'
									}"
									i18n-data-placeholder="@@option.select_client" data-placeholder="Please type client name" 
									formControlName="client_id"
								><option></option></select>
								<span class="field-error client-error" i18n="@@error.required">Required</span>
						</fieldset>

						<div class="online-payment-row">
								<ng-container i18n="@@invoices.quickpayment.please_enter_amount">Please insert your Amount</ng-container>
								<fieldset [ngClass]="{'has-error': submitted && quickPaymentForm.get('amount').errors?.required}">
									<input type="number" formControlName="amount" placeholder="0" /><span class="percent currency">SAR</span>

									<span class="field-error amount-error" *ngIf="submitted && quickPaymentForm.get('amount').errors?.required" i18n="@@error.required">Required</span>
									<div class="text-danger" *ngIf="quickPaymentForm.get('amount').errors?.min" i18n="@@error.min_amount"> Amount must be greater than {{ 0 | myCurrency }} </div>
								</fieldset>
						</div>
						
				</form>
		</div>
</div>
<div class="modal-footer">
		<ng-container  *ngIf="paymentResponse; else submitButton">
			<ng-container i18n="@@invoices.quickpayment.auto_generated_link">Auto Generated Link</ng-container>
			<input type="text" [(ngModel)]="paymentResponse.payment_link" readonly #paymentLinkInput/>
			<button type="button" class="tu-btn blue" (click)="copyLink(paymentLinkInput)" i18n="@@invoices.quickpayment.copy_link">Copy Link</button>
		</ng-container>

		<ng-template #submitButton>
			<button type="button" class="tu-btn blue" (click)="submit()" i18n="@@button.submit">Submit</button>
		</ng-template>
</div>